<div class="login blank-layout-container justify-content-center">
  <div class="position-relative row w-100 h-100" style="flex-wrap: nowrap;">
    <div
      class="col-lg-7 col-xl-8 bg-gredient p-0 leftSideLogin"
      style="background-image: url(/assets/images/logos/loginBackground.png)"
    ></div>
    <div class="col-lg-5 col-xl-4 p-0">
      <div
        class="overall p-32 d-flex align-items-start align-items-lg-center justify-content-center h-100"
      >
        <div class="justify-content-center w-100 h-100">
          <div style="height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
            <div class="selectLanguage">
              <!-- --------------------------------------------------------------- -->

              <!-- --------------------------------------------------------------- -->
              <!-- langugage Dropdown -->
              <!-- --------------------------------------------------------------- -->
              <button [matMenuTriggerFor]="flags" class="flagButton">
                <img
                  alt="flag"
                  [src]="selectedLanguage.icon"
                  class="rounded object-cover icon-20"
                />
                <p style="padding-left: 7px;color:#3A4752; margin: 0px;">{{selectedLanguage.language}}</p>

                <i-tabler
                  name="chevron-down"
                  class="icon-18 m-r-4"
                  style="color: gray; cursor: pointer"
                ></i-tabler>

              </button>
              <mat-menu #flags="matMenu" class="cardWithShadow">
                @for(lang of languages; track lang.language) {
                <button mat-menu-item (click)="changeLanguage(lang)">
                  <div class="d-flex align-items-center">
                    <img
                      alt="flag"
                      [src]="lang.icon"
                      class="rounded object-cover m-r-8 icon-20"
                    />
                    <span class="mat-subtitle-1 f-s-14">{{
                      lang.language
                    }}</span>
                  </div>
                </button>
                }
              </mat-menu>
            </div>

            <div class="loginForm">

            <div class="titleGrey">
              <img
                src="/assets/images/logos/title.png"
                alt="sunriseTitle"
                width="100%"
                class="m-r-8"
                fetchpriority="high"
              />
              <p>{{ "login.authoringToolDescription" | translate }}</p>
            </div>

            <form class="m-t-30" [formGroup]="login" (ngSubmit)="submitLogin()">
              <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{
                "login.email" | translate
              }}</mat-label>
              <mat-form-field
                appearance="outline"
                class="w-100"
                color="primary"
              >
                <input matInput formControlName="email" />
                @if(f['email'].touched && f['email'].invalid) {
                <mat-hint class="m-b-16 error-msg">
                  @if(f['email'].errors && f['email'].errors['required']) {
                  <div class="text-error">
                    {{ "login.emailRequired" | translate }}.
                  </div>
                  } @if(f['email'].errors && f['email'].errors['email']) {
                  <div class="text-error">
                    {{ "login.emailFormatError" | translate }}
                  </div>
                  }
                </mat-hint>
                }
              </mat-form-field>

              <!-- password -->
              <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{
                "login.password" | translate
              }}</mat-label>
              <mat-form-field
                appearance="outline"
                class="w-100"
                color="primary"
              >
                <input
                  matInput
                  type="{{ pwdInputType }}"
                  formControlName="password"
                />
                <i-tabler
                  *ngIf="!passwordVisible"
                  name="eye"
                  class="icon-18 m-r-4"
                  style="color: gray; cursor: pointer"
                  (click)="changePasswordVisibility()"
                ></i-tabler>
                <i-tabler
                  *ngIf="passwordVisible"
                  name="eye-closed"
                  class="icon-18 m-r-4"
                  style="color: gray; cursor: pointer"
                  (click)="changePasswordVisibility()"
                ></i-tabler>
                @if(f['password'].touched && f['password'].invalid) {
                <mat-hint class="m-b-16 error-msg">
                  @if(f['password'].errors && f['password'].errors['required'])
                  {
                  <div class="text-error">
                    {{ "login.pwdRequired" | translate }}
                  </div>
                  }
                </mat-hint>
                }
              </mat-form-field>

              <div class="recoverPassword">
              <p style="cursor: pointer; width: fit-content; margin: 0px" (click)="recoverPassword()">{{ "login.recoverPassword" | translate }}</p>
              </div>

              <button
                mat-flat-button
                color="primary"
                class="w-100 blueButton"
                style="margin-top: 50px"
                [disabled]="!login.valid"
                style="cursor: pointer; width: 100% !important;"
                [ngStyle]="{ opacity: login.valid ? '1' : '0.5' }"
              >
                {{ "login.login" | translate }}
              </button>
              <!-- input -->
            </form>
          
            <div class="options">
              <a href="https://thesunriseproject.eu/sunrise/" target="_blank">
                <span class="f-w-500 blue"
                  >{{ "login.newToSunrise" | translate }}
                </span>
              </a>
              <a href="https://thesunriseproject.eu/sunrise/" target="_blank">
                <span
                  class="orange"
                  style="padding-left: 15px; font-weight: 300"
                  >{{ "login.learn" | translate }}</span
                >
              </a>
            </div>

            </div>

             <div class="footer">
          <div class="element text1">
             SUNRISE Authoring tool © {{currentYear}}  · {{ "footer.developedBy" | translate }} BRIDG OÜ
          </div>
          <div class="secondLine">
          <div class="element text2">
            <a class="noUnderline" href="/assets/AuthoringToolUserManual.html?lang={{selectedLanguage.code}}" target="_blank" style="display: flex;">
           <span style="font-weight: 500;">{{ "footer.needHelp" | translate }}</span><span style="text-decoration: underline; margin-left: 3px; cursor: pointer;">{{ "footer.checkUserManual" | translate }}</span></a>
          </div>
           <div class="element text1" style="text-decoration: underline; cursor: pointer;" (click)="navigatePrivacyPolicy()">
            {{ "footer.privacyAndCookiesPolicy" | translate }}
          </div>
          </div>
          
  
        </div>

          </div>
        </div>
         
      </div>
    </div>
  </div>
</div>
